import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

import ptBR from './locales/pt-BR.json';
import en from './locales/en.json';
import es from './locales/es.json';
import fr from './locales/fr.json';
import de from './locales/de.json';
import ar from './locales/ar.json';
import it from './locales/it.json';
import tr from './locales/tr.json';

export const SUPPORTED_LANGUAGES = ['pt-BR', 'en', 'es', 'fr', 'de', 'ar', 'it', 'tr'] as const;
export type SupportedLanguage = typeof SUPPORTED_LANGUAGES[number];

function resolveLocale(): string {
  const saved = localStorage.getItem('ott_lang');
  if (saved && SUPPORTED_LANGUAGES.includes(saved as SupportedLanguage)) return saved;

  const navLangs: readonly string[] = navigator.languages?.length
    ? navigator.languages
    : [navigator.language ?? 'en'];

  for (const lang of navLangs) {
    const base = lang.split('-')[0];
    if (lang === 'pt-BR' || lang === 'pt' || base === 'pt') return 'pt-BR';
    if (base === 'en') return 'en';
    if (base === 'es') return 'es';
    if (base === 'fr') return 'fr';
    if (base === 'de') return 'de';
    if (base === 'ar') return 'ar';
    if (base === 'it') return 'it';
    if (base === 'tr') return 'tr';
  }

  return 'en';
}

export function changeLanguage(lang: string): void {
  localStorage.setItem('ott_lang', lang);
  // Cast needed: i18next v23 types use TS5 features that TS4 can't fully resolve
  void (i18next as unknown as { changeLanguage(l: string): void }).changeLanguage(lang);
  document.documentElement.lang = lang;
  document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
  // Reload so all components pick up new RTL/LTR layout
  window.location.reload();
}

const resolvedLang = resolveLocale();

i18next.use(initReactI18next).init({
  resources: {
    'pt-BR': { translation: ptBR },
    en: { translation: en },
    es: { translation: es },
    fr: { translation: fr },
    de: { translation: de },
    ar: { translation: ar },
    it: { translation: it },
    tr: { translation: tr },
  },
  lng: resolvedLang,
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

// Apply lang/dir immediately on init
document.documentElement.lang = resolvedLang;
document.documentElement.dir = resolvedLang === 'ar' ? 'rtl' : 'ltr';

export default i18next;
